module.exports = __webpack_public_path__ + "static/media/stack.c4d487b6.png";